
declare const gtag: Function
import Vue from "vue";

import OptionsDropdown from "@/components/OptionsDropdown.vue";
import optionsStore from "@/state/modules/options";
import partnersStore from "@/state/modules/partners";

export default Vue.extend({
	name: "partners-page",
	page: {
		title: "Partners",
		meta: [
			{
				name: "description",
				content: "Page to view and edit partners",
			},
		],
	},
	components: {
		OptionsDropdown,
	},
	props: {
		theme: String,
	},
	computed: {
		partners() {
			return partnersStore.state.partners;
		},
		partnersToken(): string {
			return partnersStore.state.partnersToken;
		},
		partnerTypeOptions(): ISelectOption[] {
			return optionsStore.state.partnerType;
		},
		officeIdOptions(): ISelectOption[] {
			return optionsStore.state.officeId;
		},
	},
	data(): any {
		return {
			filters: {
				sortBy: "name",
				sortAscending: true,
				searchString: "",
				searchOnKeys: "uniqueId",
			},
			filterOptions: {}
		}
	},
	created() {
		partnersStore.dispatchGetPartners({ params: this.filters });
	},
	beforeMount() {
		this.filterOptions = this.defaultFilters();
		this.resetFilters();
	},
	methods: {
		changeSort(sortBy: string) {
			gtag('event', sortBy, { 'event_category': 'Partners', 'event_label': 'SortBy'});
			if (this.filters.sortBy === sortBy) {
				this.filters.sortAscending = !this.filters.sortAscending;
			} else {
				this.filters.sortBy = sortBy;
				this.filters.sortAscending = true;
			}
			partnersStore.dispatchGetPartners({ params: this.filters });
		},
		addPartner() {
			gtag('event', 'addPartner', { 'event_category': 'Partners', 'event_label': 'addPartner'});
			this.$router.push("/partners/add-partner");
		},
		editPartner(id: string) {
			gtag('event', 'editPartner', { 'event_category': 'Partners', 'event_label': 'editPartner'});
			this.$router.push(`/partners/edit-partner?id=${id}`);
		},
		defaultFilters() {
			return {
				partnerType: "",
				officeId: "",
			}
		},
		setFilters() {
			for (const [key, value] of Object.entries(this.filterOptions)) {
				if (value) {
					if ((value as any)["value"]) {
						this.filters[key] = (value as any)["value"];
					} else {
						this.filters[key] = value;
					}
				} else {
					delete this.filters[key];
				}
			}
		},
		submitFilters() {
			gtag('event', 'submitFilter', { 'event_category': 'Partners', 'event_label': 'Filter'});
			this.setFilters();
			partnersStore.dispatchGetPartners({ params: this.filters });
			this.$refs.filterOptionsDropdown.onCloseOptions();
		},
		resetFilters() {
			this.filterOptions.partnerType = this.filters.partnerType === "" ? "" : this.partnerTypeOptions.find((option: ISelectOption) => option.value === this.filters.partnerType);
			this.filterOptions.officeId = this.filters.officeId === "" ? "" : this.officeIdOptions.find((option: ISelectOption) => option.value === this.filters.officeId);
		},
		clearFilters() {
			gtag('event', 'clearFilter', { 'event_category': 'Partners', 'event_label': 'Filter'});
			this.filterOptions = this.defaultFilters();
			this.setFilters();
			partnersStore.dispatchGetPartners({ params: this.filters });
			this.$refs.filterOptionsDropdown.onCloseOptions();
		},
		loadMore() {
			gtag('event', 'loadMore', { 'event_category': 'Partners', 'event_label': 'loadMore'});
			partnersStore.dispatchGetPartners({ params: { ...this.filters, continuationToken: this.partnersToken } });
		},
	}
});
